import classnames from 'classnames';
import React, { forwardRef } from 'react';
import styles from "./ButtonLink.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ButtonLink = /*#__PURE__*/forwardRef(({
  className,
  onClick,
  secondary,
  disabled,
  children,
  inputRef,
  variant,
  small,
  fullWidth,
  ...rest
}, ref) => {
  const Component = disabled ? 'span' : 'a';
  const classes = classnames(styles.link, variant ? classnames(styles[variant], styles[variant]) : styles.button, secondary && styles.secondary, small && styles.small, fullWidth && styles.fullWidth, disabled && styles.disabled, className);
  const commonProps = {
    rel: !disabled ? 'noopener' : undefined,
    onClick: !disabled ? onClick : undefined,
    className: classes,
    ...rest
  };
  return /*#__PURE__*/_jsx(Component, {
    ...commonProps,
    ref: ref ?? inputRef,
    children: children
  });
});